import axios from "axios";
import dayjs from "dayjs";

export const smallScreen = 460;
export const mediumScreen = 820;
export const mediumScreenH = 750;

export const trnsColors = {
  Charge: {
    backgroundColor: "var(--badge-background-red)",
    textColor: "var(--badge-text-red)",
  },
  Encaissement: {
    backgroundColor: "var(--badge-background-green)",
    textColor: "var(--badge-text-green)",
  },
  Transfert: {
    backgroundColor: "var(--badge-background-blue)",
    textColor: "var(--badge-text-blue)",
  },
  "Augmentation de capital": {
    backgroundColor: "var(--badge-background-purple)",
    textColor: "var(--badge-text-purple)",
  },
  Versement: {
    backgroundColor: "var(--badge-background-orange)",
    textColor: "var(--badge-text-orange)",
  },
  Benefice: {
    backgroundColor: "var(--badge-background-teal)",
    textColor: "var(--badge-text-teal)",
  },
  "Retrait de capital": {
    backgroundColor: "var(--badge-background-brown)",
    textColor: "var(--badge-text-brown)",
  },
};

export function reportError(
  errorMessage,
  appName = "UnknownApp",
  errorFile = "",
  errorLine = "",
) {
  return axios.post(
    "https://sarah.digitarts.cloud/help/error_repport.php",
    {
      appName,
      errorMessage,
      errorFile,
      errorLine,
    },
    {
      headers: {
        "content-type": "application/json, multipart/form-data",
        Accept: "application/json",
      },
      // withCredentials: false, // mets true si tu dois envoyer des cookies/session
    },
  );
}

export const fetchCaisse = async (uid) => {
  if (uid === localStorage.getItem("uid")) {
    const response = await axiosGetAction("_usr.php", "getc", {
      headers: getHeader(),
    });
    if (response.data.err && response.data.err !== "-1") {
      const elem = document.getElementById("userBalance");
      if (elem) elem.innerHTML = "";
      alert(response.data.err);
    } else {
      axiosResponse(response, () => {
        const elem = document.getElementById("userBalance");
        if (elem) elem.innerHTML = formatNumber2(response.data.jData, 0);
        // console.log("fetchCaisse response:", response.data);
      });
    }
  }
};
export const fetchCaisseUpd = async (uid) => {
  try {
    const response = await axiosGetAction("_usr.php", "getc", {
      headers: getHeader(),
    });
    if (response.data.err && response.data.err !== "-1") {
      console.error("Erreur dans la réponse :", response.data.err);
      const elem = document.getElementById("userBalance");
      if (elem) elem.innerHTML = "";
      alert(response.data.err);
    } else {
      axiosResponse(response, () => {
        const elem = document.getElementById("userBalance");
        if (elem) elem.innerHTML = formatNumber2(response.data.jData, 2);
      });
    }
  } catch (error) {
    console.error("Erreur réseau ou interne dans fetchCaisse :", error);
  }
};

//Global functions that can be used in diffrent projects
//treat the response from api axios
export function axiosResponse(response, f = () => {}) {
  if (response.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    //console.log(response.response.data);
    //console.log(response.response.status);
    //console.log(response.response.headers);
    /* if(response.response.status>400){
       localStorage.clear();
     }
     window.location=("/"); */
  } else if (response.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // console.log(response);
    // console.log(response.request);
    // console.log(response.message);
    //changer le lien
    if (response.request.status < 100) {
      alert("Une erreur s'est produite");
      // if(localStorage.getItem("netError")!==response.message||!window.location.pathname.split("/")[1].includes("error")){window.location=("/error?message="+response.message); }}
    }
    //else {if(localStorage.getItem("netError")!=="undefined") window.location=("/") }
    //localStorage.setItem("netError",response.message);
  } else {
    // Something happened in setting up the request that triggered an Error
    //console.log('Error', response.message);
  }
  if (response.data) {
    if (response.data.err == null) {
      f();
    } else {
      if (localStorage.length !== 0) {
        if (response.data.err === "-1") {
          alert("Votre session est expiré");
          localStorage.clear(); //we have saved some data in local storage on login so it must be cleared when the session is expired
          window.location = "/"; // to return to login page
        } else {
          alert(response.data.err);
        }
      }
    }
  }
}

export function axiosResponseV2(
  response,
  showAlert,
  onSuccess = () => {},
  setData = () => {},
  options = {},
) {
  const {
    showSuccess = true,
    showError = true,
    customMessages = {}, // { success: "text", error: "text" }
  } = options;

  try {
    if (!response?.data) {
      if (showError)
        showAlert(
          customMessages.error || "Réponse invalide du serveur.",
          "error",
        );
      return;
    }

    const { success, message, data } = response.data;

    if (success) {
      const msg = customMessages.success ?? message;
      if (msg && showSuccess) showAlert(msg, "success");
      setData(data);
      onSuccess(data, setData);
    } else {
      setData(null);
      const msg = customMessages.error ?? message;
      if (msg && showError) showAlert(msg, "error");

      if (
        message?.toLowerCase().includes("-1") ||
        message?.includes("expiré")
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
  } catch (err) {
    console.error("Erreur dans axiosResponseV2:", err);
    if (showError)
      showAlert(
        customMessages.error ||
          "Erreur interne lors du traitement de la réponse.",
        "error",
      );
  }
}

//get headers
export function getHeader() {
  const param = JSON.parse(localStorage.getItem("param"));
  const headers = {
    "content-type": "application/json, multipart/form-data",
    session: localStorage.getItem("token"),
    appID: param.appID,
  };
  return headers;
}
//get headers in case of FormData
export function getHeader2() {
  const param = JSON.parse(localStorage.getItem("param"));
  const headers = {
    "Content-Type": "multipart/form-data",
    session: localStorage.getItem("token"),
    appID: param.appID,
  };
  return headers;
}
// manage the ajax's errors in datatables
export function errorMan(data) {
  if (data.err != null && data.err !== undefined) {
    if (data.err === "-1") {
      alert("votre session est expiré ");
      localStorage.setItem("isLoged", false);
      window.location = "/";
    } else alert(data.err);
  }
}
//test if an object is empty
export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}
export const isObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

//get service
// export function axiosGetAction(api, service) {
//   const param = JSON.parse(localStorage.getItem("param"));
//   const response = axios({
//     method: "GET",
//     url: param.urlService + api + "?do=" + service,
//     headers: getHeader(),
//   }).catch(function (error) {
//     error["data"] = "";
//     return error;
//   });
//   return response;
// }
// //POST axios json
// export function axiosPostAction(api, service, data) {
//   const param = JSON.parse(localStorage.getItem("param"));
//   var headers = getHeader2();
//   if (!(data instanceof FormData)) {
//     data = JSON.stringify(data);
//     headers = getHeader();
//   }
//   const response = axios({
//     method: "POST",
//     url: param.urlService + api + "?do=" + service,
//     headers: headers,
//     data: data,
//   }).catch(function (error) {
//     error["data"] = "";
//     return error;
//   });
//   return response;
// }

//get user infornations
export const getInfo = () => {
  const info = {
    name: localStorage.getItem("name"),
    session: localStorage.getItem("token"),
  };
  return info;
};

// group by key function
export const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue,
    );
    return result;
  }, {});
};

// join two arrays of objects in a prop
export const merge = (a, b, prop) => {
  let merged = [];
  for (let i = 0; i < a.length; i++) {
    merged.push({
      ...a[i],
      ...b.find((itmInner) => itmInner[prop] === a[i][prop]),
    });
  }
  return merged;
};

export const getDate = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();

  today = dd + "-" + mm + "-" + yyyy;
  return today;
};

export const getDate2 = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();

  today = yyyy + "-" + mm + "-" + dd;
  return today;
};

export const dateReverse = (date) => {
  return date?.split("-")?.reverse()?.join("-");
};
export const dateReverse2 = (dateTime) => {
  // Assurez-vous que la dateTime est bien au format attendu
  const [datePart, timePart] = dateTime.split(" ");
  const [year, month, day] = datePart.split("-");
  return `${day}-${month}-${year} ${timePart}`;
};
export const formatDate = (today) => {
  if (!today) return null;
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();

  today = dd + "-" + mm + "-" + yyyy;
  return today;
};
export const formatDate1 = (today) => {
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();

  today = yyyy + "-" + mm + "-" + dd;
  return today;
};

export const formatDate2 = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
export const normalDate = (today) => {
  var dateParts = today.split("-");
  var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  return dateObject;
};

//delete an item from an array of object by some attribute
export function removeItemsByAtt(arr, value, att) {
  var index = arr
    .map((x) => {
      return x[att];
    })
    .indexOf(value);
  arr.splice(index, 1);
  return arr;
}

//return the index of an Object by a property value
export function getIndex(arr, val, att) {
  var index = arr
    .map((x) => {
      return x[att];
    })
    .indexOf(val);
  return index;
}
//eliminer les espaces pour les chaines de caractere
export const DeleteSpace = (edt) => {
  do {
    var index = edt.indexOf("&nbsp;");
    if (index !== -1) {
      edt = edt.replace("&nbsp;", "");
      //edt=edt.replace(" ","")
    }
  } while (edt.indexOf("&nbsp;") !== -1);
  var text = edt.replace(/<[^>]*>/g, "");
  /*do{
    var ind = edt.indexOf("<div>");
    if(ind!==-1){ 
      edt=edt.replace("<div>"," ");
      edt=edt.replace("<br>"," ");
      edt=edt.replace("</div>"," ");
    }   
  } while (edt.indexOf("<div>")!==-1);*/
  /* do{
     var ind = edt.indexOf("</r>");
     if(ind!==-1){ 
       edt=edt.replace("</r>","");
     }   
   } while (edt.indexOf("/r")!==-1);*/
  return text;
};
//remove unwanted spaces
export const DeleteSpace2 = (edt) => {
  edt = edt.replace(/&nbsp;/g, "");
  return edt.replace(/\s\s+/g, " ").trim();
};

//get all keys
export const getKeys = (obj) => {
  const filters = [];
  Object.keys(obj).map((key) => {
    const f = {};
    f["att"] = key;
    filters.push(f);
    return true;
  });
  return filters;
};

//filter all (search multi creterias)
export const searchAll = (data, filters, search) => {
  const dat = data;
  return dat.filter((d) =>
    filters.some((filterEl) =>
      d[filterEl.att].toString().toLowerCase().includes(search.toLowerCase()),
    ),
  );
};

//get next element
export const navObj = (obj, currentKey, direction) => {
  return Object.keys(obj).indexOf(currentKey) + direction;
};

//get Time in seconds from hours and minutes
export const getClock = (date) => {
  var seconds = date.getSeconds();
  var minutes = date.getMinutes();
  var hour = date.getHours();
  return hour + ":" + minutes + ":" + seconds;
};

//get x last days
export function LastXDay(x) {
  var d = new Date();
  d.setDate(d.getDate() - x);
  return d;
}

//check if phone number
export function phonenumber(inputtxt) {
  //var phoneno = /^\d{10}$/;
  var phoneno = "[0][5-7][4-7][0-9][0-9][0-9][0-9][0-9][0-9][0-9]";
  if (inputtxt.match(phoneno)) {
    return { response: true, message: "C'est le bon format" };
  } else
    return { response: false, message: "Vous devez insérer le bon format" };
}

//Check if it is the same day
export const datesAreOnSameDay = (first, second) => {
  if (!first || !second) return false;
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate()
  );
};

// export function formatNumber(val, dec) {
//   return Intl.NumberFormat(undefined, { maximumFractionDigits: dec }).format(
//     val
//   );
// }
export function formatCompactNumber(num) {
  return new Intl.NumberFormat("fr", {
    notation: "compact",
    compactDisplay: "short",
  }).format(num);
}

export function formatNumber(val) {
  return Intl.NumberFormat().format(val);
}

// export function formatNumber2(val, dec) {
//   if (!val && val !== 0) return "?";
//   return Intl.NumberFormat(undefined, {
//     minimumFractionDigits: Number.isInteger(val) ? 0 : dec,
//     maximumFractionDigits: Number.isInteger(val) ? 0 : dec,
//   }).format(val);
// }
export function formatNumber2(val, dec) {
  if (val == null) return "?";

  const num = Number(val);
  if (Number.isNaN(num)) return "?";

  const digits = Number.isInteger(num) ? 0 : dec;

  const rounded = Number(num.toFixed(digits));

  const safe = Object.is(rounded, -0) ? 0 : rounded;

  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(safe);
}

export function formatNumberEspaces(number) {
  var parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
}

//Check if valide date
export const dateIsValide = (day) => {
  if (day === null || undefined) return false;
  return (
    Object.prototype.toString.call(day) === "[object Date]" &&
    !isNaN(day) &&
    (datesAreOnSameDay(new Date(), day) || day.getTime() < new Date().getTime())
  );
};
//fetch update elemnt
export const updateElem = (id, val) => {
  var elem = document.getElementById(id);
  if (elem != null && elem !== undefined) elem.innerHTML = val;
};
//fetch update elemnumber
export const updateElemN = (id, val) => {
  var elem = document.getElementById(id);
  if (elem != null && elem !== undefined)
    elem.innerHTML = new Intl.NumberFormat().format(val);
};
//fetch update elem string
export const updateElemS = (id, val) => {
  var elem = document.getElementById(id);
  if (elem != null && elem !== undefined) elem.innerHTML = val;
};

//calculate unique items
export function countTableId(a, att) {
  // sets are, well, sets of unique items. no duplicates allowed
  let uniqueId = new Set();
  for (let elem of a) {
    uniqueId.add(elem[att]);
  }
  // the size of the set is the number of unique items we added
  return uniqueId.size;
}
//if empty string returns null
export function stringToNull(str) {
  if (str === "") return null;
  return str;
}
//if empty string returns null
export function zeroToNull(val) {
  if (val === 0) return null;
  return val;
}

//check if a number is odd
export function isOdd(num) {
  return num % 2;
}

//sum of value in an array of objects
export function sumArObj(arr, att) {
  const sum = arr.reduce((accumulator, object) => {
    return accumulator + object[att];
  }, 0);
  return sum;
}

//calcilate the item that are superior to something
export function supTo(arr, att, value) {
  let cpt = 0;
  cpt = arr.reduce((accumulator, object) => {
    if (object[att] > value) return accumulator + 1;
    return accumulator + 0;
  }, 0);
  return cpt;
}
//calcilate the item that are inferior to something
export function infTo(arr, att, value) {
  let cpt = 0;
  cpt = arr.reduce((accumulator, object) => {
    if (object[att] < value) return accumulator + 1;
    return accumulator + 0;
  }, 0);
  return cpt;
}

//format to 2 decimals to use it do : formatterTo2.format(Some value)
export const formatterTo2 = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const getParams = async () => {
  var param = null;
  const cacheBuster = Math.random();
  await fetch(`/param.json?cacheBuster=${cacheBuster}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
    .then(async function (response) {
      param = await response.json();
      //localStorage.setItem('urlService', true);
      //localStorage.setItem('appID',response.data.jData.name);
    })
    .then(function (myJson) {
      //console.log(myJson);
    });
  return param;
};

export function addDays(date, days) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}

export function getDates(startDate, stopDate) {
  var dateArray = [];
  var currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(currentDate);
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

//add days between two days to an array
export function getDates1(startDate, endDate) {
  let dates = [];
  let currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
}

export const ConcatDate = (day) => {
  var dd = String(day.getDate()).padStart(2, "0");
  var mm = String(day.getMonth() + 1).padStart(2, "0");
  var today = mm + dd;
  return today;
};

export const couleur = () => {
  return "#" + (((1 << 24) * (Math.random() + 1)) | 0).toString(16).substr(1);
};

export const couleurs = (val) => {
  var tab = [];
  for (let pas = 0; pas < val; pas++) {
    var col = "#" + ((Math.random() * 0xffffff) << 0).toString(16);
    if (col !== "#000000" && col !== "#FFFFFF") {
      tab.push(col);
    }
  }
  return tab;
};

export const rgbToHex = (rgb) => {
  //console.log(rgb)
  var index = rgb.indexOf("rgb");
  if (index !== -1) {
    const rgbExcludeFirst = rgb.split("rgb(")[1];
    const rgbExcludeLast = rgbExcludeFirst.split(")")[0];
    const rgbValueArray = rgbExcludeLast.split(",");
    const first = Number(rgbValueArray[0]).toString(16);
    const second = Number(rgbValueArray[1]).toString(16);
    const third = Number(rgbValueArray[2]).toString(16);
    return "#" + first + second + third;
  } else return rgb;
};

export const ColorApp = (col) => {
  switch (col) {
    case "iRahati":
      return "#4cb050";
    case "Boutiqa":
      return "#9a2120";
    default:
      return "#482e1e";
  }
};

export function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

export const DateDebMonth = (mois, annee) => {
  var today = new Date();
  return annee !== ""
    ? new Date(annee, mois - 1, 1)
    : new Date(today.getFullYear(), mois - 1, 1);
};

export const DateFinMonth = (mois, annee) => {
  var today = new Date();
  return annee !== ""
    ? new Date(annee, mois, 0)
    : new Date(today.getFullYear(), mois, 0);
};

const getTrimMonth = (trim) => {
  switch (trim) {
    case 1:
      return ["01", "03"];
    case 2:
      return ["04", "06"];
    case 3:
      return ["07", "09"];
    default:
      return ["10", "12"];
  }
};

export const TrimDebFin = (trim, annee) => {
  var result = [];
  var array = getTrimMonth(trim);
  result.push(DateDebMonth(array[0], annee));
  result.push(DateFinMonth(array[array.length - 1], annee));
  return result;
};
export const AnnDebFin = (ann, date1, date2) => {
  var dd = String(date1.getDate()).padStart(2, "0");
  var mm = String(date1.getMonth() + 1).padStart(2, "0");
  var day = new Date(ann, mm - 1, dd);

  var dd1 = String(date2.getDate()).padStart(2, "0");
  var mm1 = String(date2.getMonth() + 1).padStart(2, "0");
  var day1 = new Date(ann, mm1 - 1, dd1);
  return [day, day1];
};
/*export const getyear=()=>{
 var today=new Date()
 console.log(today)
 var date =today.getFullYear()
 console.log(date)
 const array=[{id:1,name:(date).toString()},{id:2,name:(date-1).toString()},{id:3,name:(date-2).toString()},{id:4,name:(date-3).toString()},
              {id:5,name:(date-4).toString()}]
 console.log(array)
 return array;
}

export const getMonthYear=(ann)=>{
 console.log(ann)
 var array=[]
   var today=new Date()
   var monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  if(ann===1){
   var mm = String(today.getMonth() + 1).padStart(2, '0'); 
   console.log(mm,mm.substr(1)-1)
   console.log(monthNames.slice(0,mm.substr(1)-1))
   var m=monthNames.slice(0,mm.substr(1)-1)
   monthNames.map((el,index)=>{
     array.push({id:index+1,name:el})
   })
   console.log(array)
   return array
  }else{
   return [{id:1,name:"Janvier"},{id:2,name:" Février"},{id:3,name:"Mars"},{id:4,name:"Avril"},
           {id:5,name:"Mai"},{id:6,name:"Juin"},{id:7,name:"Juillet"},{id:8,name:"Août"},
           {id:9,name:"Septembre"},{id:10,name:"Octobre"},{id:11,name:"Novembre"},{id:12,name:"Décembre"}];
  }
}

export const getTrimYear=()=>{
 var today=new Date()
 console.log(today)
 var date =today.getFullYear()
 console.log(date)
 const array=[{id:1,name:(date).toString()},{id:2,name:(date-1).toString()},{id:3,name:(date-2).toString()},{id:4,name:(date-3).toString()},
              {id:5,name:(date-4).toString()}]
 console.log(array)
 return array;
}*/

export function getYear(date) {
  var yyyy = date.getFullYear();
  return yyyy.toString();
}

export function MonthName(num) {
  switch (num) {
    case "01":
      return "Janvier";
    case "02":
      return "Fevrier";
    case "03":
      return "Mars";
    case "04":
      return "Avril";
    case "05":
      return "Mai";
    case "06":
      return "Juin";
    case "07":
      return "Juillet";
    case "08":
      return "Aout";
    case "09":
      return "Septembre";
    case "10":
      return "Octobre";
    case "11":
      return "Novembre";
    default:
      return "Decembre";
  }
}
export function MonthName1(num) {
  switch (num) {
    case "Janvier":
      return "01";
    case "Fevrier":
      return "02";
    case "Mars":
      return "03";
    case "Avril":
      return "04";
    case "Mai":
      return "05";
    case "Juin":
      return "06";
    case "Juillet":
      return "07";
    case "Aout":
      return "08";
    case "Septembre":
      return "09";
    case "Octobre":
      return "10";
    case "Novembre":
      return "11";
    default:
      return "12";
  }
}
export function getMonth(date) {
  var mm = String(date.getMonth() + 1).padStart(2, "0");
  var monthName = MonthName(mm);
  return monthName;
}

export function include(arr, obj) {
  if (arr.length === 0) {
    return false;
  } else {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === obj) {
        return true;
      }
    }
    return false;
  }
}
export function isHex(str) {
  var regex = /[0-9A-Fa-f]{6}/g;
  if (str.match(regex)) {
    return true;
  } else {
    return false;
  }
}
// export function isNumeric(str) {
//   if (typeof str != "string") return false; // we only process strings!
//   return (
//     !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
//     !isNaN(parseFloat(str))
//   ); // ...and ensure strings of whitespace fail
// }
//Vérifie l'égalité de deux tableau
export function isEqual(array1, array2) {
  let isEqual = true;
  if (array1.length !== array2.length) {
    isEqual = false;
  } else {
    for (let i = 0; i < array1.length; i++) {
      if (array1[i] !== array2[i]) {
        isEqual = false;
        break;
      }
    }
  }
  return isEqual;
}
//fonction pour detecter l'element manquant d'un tableau par rapport un autre
export function MissingElem(array1, array2) {
  const missElem = array2.find((element) => !array1.includes(element));
  return missElem;
}
//fonction pour detecter tous les elements manquant d'un tableau par rapport un autre
export function MissingElems(array1, array2) {
  const missElem = array2.filter((element) => !array1.includes(element));
  return missElem;
}
//fonction pour detecter tous les elements manquant d'un tableau d'objets par rapport un autre tableau simple
export function MissingObjs(array1, array2, att) {
  const missObjs = array2.filter(
    (obj2) => !array1.some((obj1) => obj2 === obj1[att]),
  );
  return missObjs;
}

export function sortTable(data, att) {
  const sortedData = data.sort((a, b) => {
    if (a[att] < b[att]) {
      return -1;
    } else if (a[att] > b[att]) {
      return 1;
    }
    return 0;
  });
  return sortedData;
}
export function trouverOccurrencesParCle(tableau, cle, valeurRecherchee) {
  return tableau.filter((element) => element[cle] === valeurRecherchee);
}

export const monthsPassed = (inputDate, months) => {
  if (!inputDate) return true;
  months = JSON.parse(months);
  // Convert the input date to a Date object
  const [year, month, day] = inputDate.split("-");
  const pastDate = new Date(`${year}-${month}-${day}`);

  const pastDatePlusXMonths = new Date(pastDate);
  pastDatePlusXMonths.setMonth(pastDatePlusXMonths.getMonth() + months);

  // Get the current date
  const currentDate = new Date();

  // Return true if the current date is greater than the calculated date
  return currentDate > pastDatePlusXMonths;
};

export const addPagePattern = (bodyClass, titlesClass, mainTitleClass) => {
  document.body.classList.add(bodyClass);

  // to change the title tab colors
  const elements = document.querySelectorAll(
    ".pageTitleElem, .horizontal-line",
  );
  elements.forEach((element) => {
    element.classList.add(titlesClass);
  });

  const element = document.querySelector(".pageTitleElemMain");
  element.classList.add(mainTitleClass);
};

export const removePagePattern = (bodyClass, titlesClass, mainTitleClass) => {
  document.body.classList.remove(bodyClass);

  // to change the title tab colors
  const elements = document.querySelectorAll(
    ".pageTitleElem, .horizontal-line",
  );
  elements.forEach((element) => {
    element.classList.remove(titlesClass);
  });

  const element = document.querySelector(".pageTitleElemMain");
  element.classList.remove(mainTitleClass);
};

// mutationObserverUtils.js

export const changeDataTableHeadRow = (
  className,
  targetNode = document.body,
) => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        const elements = document.querySelectorAll(".rdt_TableHeadRow");
        elements.forEach((element) => {
          element.classList.add(className);
        });
      }
    });
  });

  observer.observe(targetNode, { childList: true, subtree: true });

  return observer;
};

// add by imene
export const fetchParam = async () => {
  const response = await axiosGetAction("_prm.php", "gets");
  if (response.data.err && response.data.err !== "-1") {
    return response.data.err;
  } else {
    axiosResponse(response, () => {
      localStorage.setItem(
        "defaultParams",
        JSON.stringify(response.data.jData),
      );
    });
    return response.data.jData;
  }
};
export async function autorise(
  typeId,
  id,
  showAlert,
  onSuccess,
  setLoading,
  api,
  service,
  alertMessage,
) {
  setLoading(true);
  var formData = new FormData();
  formData.append("typId", typeId);
  formData.append("id", id);
  const response = await axiosPostAction(api, service, formData);
  if (response.data.err && response.data.err !== "-1") {
    showAlert(response.data.err, "error");
    setLoading(false);
  } else {
    axiosResponse(response, () => {
      if (response.data.jData) {
        showAlert(alertMessage, "success");
        setLoading(false);
        onSuccess();
      }
    });
  }
}

export async function fetchBenefc(id, showAlert) {
  var formData = new FormData();
  formData.append("frnsId", id);
  const response = await axiosPostAction("_frs.php", "getbnf", formData);

  if (response.data.err && response.data.err !== "-1") {
    showAlert(response.data.err, "error");
  } else if (response.data.jData) {
    return response.data.jData;
  } else {
    console.error("La réponse ne contient pas 'jData'");
    return null;
  }
}

export const getDaysInCurrentMonth = () => {
  const currentDate = new Date();
  // Créer une date pour le premier jour du mois suivant
  const firstDayNextMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    1,
  );
  // Utiliser setDate(0) pour obtenir le dernier jour du mois actuel
  firstDayNextMonth.setDate(0);
  // console.log(firstDayNextMonth.getDate());
  return firstDayNextMonth.getDate(); // Renvoie le nombre de jours dans le mois en cours
};

export const formatSerial = (value) => {
  // Remove any non-digit characters
  // const digitsOnly = value;
  const digitsOnly = String(value);
  // Format string with spaces from the right side: ## ####
  const formatted =
    digitsOnly.slice(0, -6) + // All but the last 6 characters
    (digitsOnly.length > 6 ? " " : "") + // Space before last 6 characters
    digitsOnly.slice(-6, -4) + // Characters from -6 to -4
    (digitsOnly.length > 4 ? " " : "") + // Space before last 4 characters
    digitsOnly.slice(-4); // Last 4 characters

  return formatted;
};

export const sumValues = (data) => {
  return data.reduce((total, item) => {
    // Pour chaque objet dans le tableau
    Object.values(item).forEach((arr) => {
      arr.forEach((innerArray) => {
        innerArray.forEach((obj) => {
          // Ajoutez les valeurs à la somme
          total += Object.values(obj).reduce((sum, value) => sum + value, 0);
        });
      });
    });
    return total;
  }, 0);
};

export function getPreviousMonthDate(date) {
  const previousMonthDate = new Date(date);
  previousMonthDate.setMonth(previousMonthDate.getMonth() - 1); // Soustrait 1 mois
  return previousMonthDate;
}

export const sumValues2 = (data) => {
  return data.reduce((accumulator, item) => accumulator + item.count, 0);
};

export function calculateWarehouseSums(data) {
  const warehouseSums = [];

  data.forEach((item) => {
    Object.values(item).forEach((nestedArray) => {
      nestedArray.forEach((innerArray) => {
        innerArray.forEach((warehouseObj) => {
          // Pour chaque objet contenant les warehouses
          Object.entries(warehouseObj).forEach(([warehouse, value]) => {
            // Cherche si l'entrepôt existe déjà dans warehouseSums
            const existingWarehouse = warehouseSums.find(
              (w) => w.warehouse === warehouse,
            );

            if (existingWarehouse) {
              // Si l'entrepôt existe, ajoute la valeur à la somme
              existingWarehouse.sum += value;
            } else {
              // Sinon, crée une nouvelle entrée dans la liste
              warehouseSums.push({ warehouse, sum: value });
            }
          });
        });
      });
    });
  });
  return warehouseSums;
}

export function getTableHeadClass(typeId) {
  switch (typeId) {
    case 1:
      return "topupTableHead";
    case 2:
      return "voucherTableHead";
    case 4:
      return "simTableHead";
    case 3:
      return "scratchTableHead";
    default:
      return "";
  }
}

export const isNumeric = (val) => {
  if (typeof val === "number") return true;
  else return typeof val === "string" && /^[0-9]+$/.test(val);
};

export function hexToRgba(hex, alpha = 0.2) {
  let r = 0,
    g = 0,
    b = 0;

  // Remove the `#` if it's there
  hex = hex.replace("#", "");

  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function processCumulData(rawData, att) {
  // Step 1: Normalize dates and group by date
  if (!rawData?.length) return [];
  const dailySoldMap = {};

  rawData.forEach((entry) => {
    const date = entry.date.split(" ")[0]; // "YYYY-MM-DD"
    if (!dailySoldMap[date]) {
      dailySoldMap[date] = 0;
    }
    dailySoldMap[date] += entry[att] || 0;
  });

  // Step 2: Find min and max dates
  const dates = Object.keys(dailySoldMap).sort();
  const minDate = dayjs(dates[0]);
  const maxDate = dayjs(dates[dates.length - 1]);

  // Step 3: Fill missing dates and build result
  const result = [];
  let currentDate = minDate;
  let lastSold = null;

  while (currentDate.isBefore(maxDate.add(1, "day"))) {
    const dateStr = currentDate.format("YYYY-MM-DD");

    if (dailySoldMap[dateStr] !== undefined) {
      lastSold = dailySoldMap[dateStr];
    }

    if (lastSold !== null) {
      result.push({
        date: dateStr,
        sold: lastSold,
      });
    }

    currentDate = currentDate.add(1, "day");
  }

  return result;
}
export function processData(rawData, att) {
  if (!rawData?.length) return [];

  // Step 1: sort by full datetime ascending
  const sortedData = [...rawData].sort(
    (a, b) => new Date(a.date) - new Date(b.date),
  );

  // Step 2: keep only the last record per day
  const dailySoldMap = {};
  sortedData.forEach((entry) => {
    const date = entry.date.split(" ")[0]; // "YYYY-MM-DD"
    // overwrite so the last one of the day stays
    dailySoldMap[date] = entry[att] || 0;
  });

  // Step 3: Find min and max dates
  const dates = Object.keys(dailySoldMap).sort();
  const minDate = dayjs(dates[0]);
  const maxDate = dayjs(dates[dates.length - 1]);

  // Step 4: Fill missing dates and carry forward last known
  const result = [];
  let currentDate = minDate;
  let lastSold = null;

  while (currentDate.isBefore(maxDate.add(1, "day"))) {
    const dateStr = currentDate.format("YYYY-MM-DD");

    if (dailySoldMap[dateStr] !== undefined) {
      lastSold = dailySoldMap[dateStr]; // last entry of that day
    }

    if (lastSold !== null) {
      result.push({
        date: dateStr,
        sold: lastSold,
      });
    }

    currentDate = currentDate.add(1, "day");
  }

  return result;
}

export function areObjectsEqual(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  // Check if both have the same keys
  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
}
export function getFullHeight(selectorOrEl) {
  const el =
    typeof selectorOrEl === "string"
      ? document.querySelector(selectorOrEl)
      : selectorOrEl;

  if (!el) return 0;

  const rect = el.getBoundingClientRect().height; // content + padding + border (fractional, like DevTools)
  const styles = window.getComputedStyle(el);

  const marginTop = parseFloat(styles.marginTop) || 0;
  const marginBottom = parseFloat(styles.marginBottom) || 0;
  const borderTop = parseFloat(styles.borderTopWidth) || 0;
  const borderBottom = parseFloat(styles.borderBottomWidth) || 0;
  const paddingTop = parseFloat(styles.paddingTop) || 0;
  const paddingBottom = parseFloat(styles.paddingBottom) || 0;
  const h = parseFloat(styles.height) || 0;

  //console.log(selectorOrEl, marginTop, marginBottom, h, rect, rect + marginTop + marginBottom + borderTop + borderBottom + paddingTop + paddingBottom)

  return (
    rect +
    marginTop +
    marginBottom +
    borderTop +
    borderBottom +
    paddingTop +
    paddingBottom
  );
}

export function objectToFormData(obj) {
  return Object.entries(obj).reduce((fd, [key, val]) => {
    fd.append(key, val);
    return fd;
  }, new FormData());
}
export function daysUntil(dateString) {
  if (!dateString) return 0;
  const targetDate = new Date(dateString);
  const today = new Date();

  // normalize both dates to midnight (ignore hours/min/sec)
  targetDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = targetDate.getTime() - today.getTime();
  return Math.round(diffTime / (1000 * 60 * 60 * 24));
}

// parserUtils.js
export function createParser(mapping, defaults = {}) {
  return function parse(raw = {}) {
    const parsed = { ...defaults };
    for (const [key, paths] of Object.entries(mapping)) {
      const value = findFirst(raw, paths);
      if (value !== undefined) parsed[key] = value;
    }
    return parsed;
  };
}

function findFirst(obj, keys) {
  for (const key of Array.isArray(keys) ? keys : [keys]) {
    if (obj[key] !== undefined && obj[key] !== null) return obj[key];
  }
  return undefined;
}

//new

// Simple URL tester
// async function callWithFailover(method, api, service, data = null) {
//   // Get current params
//   let currentParams = JSON.parse(localStorage.getItem("param"));
//   if (
//     (!currentParams?.urls || currentParams.urls.length === 0) &&
//     !currentParams?.activeUrl
//   ) {
//     const error = new Error("Aucune URL disponible.");
//     error.data = "";
//     return error;
//   }

//   const urls = currentParams.urls ?? [currentParams?.activeUrl];
//   let workingUrl = null;
//   let finalResponse = null;

//   // Try current active URL first
//   if (currentParams.activeUrl) {
//     try {
//       const config = {
//         method,
//         url: currentParams.activeUrl + api + "?do=" + service,
//         headers: method === "GET" ? getHeader() : getHeader2(),
//         timeout: 10000,
//       };

//       if (method === "POST" && data) {
//         config.data = data;
//         if (!(data instanceof FormData)) {
//           config.headers = getHeader();
//         }
//       }

//       const response = await axios(config);

//       // If successful, use this URL and response
//       workingUrl = currentParams.activeUrl;
//       finalResponse = response;
//     } catch (error) {
//       // Current URL failed, continue to others
//       console.log(
//         `Current URL ${currentParams.activeUrl} failed:`,
//         error.message
//       );
//     }
//   }

//   // If active URL failed, try all URLs in order
//   if (!workingUrl) {
//     for (const url of urls) {
//       if (url === currentParams.activeUrl) continue; // Skip the one we already tried

//       try {
//         const config = {
//           method,
//           url: url + api + "?do=" + service,
//           headers: method === "GET" ? getHeader() : getHeader2(),
//           timeout: 10000,
//         };

//         if (method === "POST" && data) {
//           config.data = data;
//           if (!(data instanceof FormData)) {
//             config.headers = getHeader();
//           }
//         }

//         const response = await axios(config);

//         // If successful, use this URL and response
//         workingUrl = url;
//         finalResponse = response;
//         break; // Exit loop once we find a working URL
//       } catch (error) {
//         console.log(`URL ${url} failed:`, error.message);
//         continue;
//       }
//     }
//   }

//   // If no URL worked, return error
//   if (!workingUrl) {
//     const error = new Error("Toutes les URLs ont échoué.");
//     error.data = "";
//     return error;
//   }

//   // Update storage if URL changed
//   if (workingUrl !== currentParams.activeUrl) {
//     currentParams.activeUrl = workingUrl;
//     localStorage.setItem("param", JSON.stringify(currentParams));
//   }

//   return finalResponse;
// }

async function callWithFailover(method, api, service, data = null) {
  // Get current params
  let currentParams = JSON.parse(localStorage.getItem("param"));
  if (
    (!currentParams?.urls || currentParams.urls.length === 0) &&
    !currentParams?.activeUrl
  ) {
    const error = new Error("Échec de la connexion");
    error.data = "";
    return error;
  }

  const urls = currentParams.urls ?? [currentParams?.activeUrl];
  let workingUrl = null;
  let finalResponse = null;

  // Try current active URL first
  if (currentParams.activeUrl) {
    try {
      const config = {
        method,
        url: currentParams.activeUrl + api + "?do=" + service,
        headers: method === "GET" ? getHeader() : getHeader2(),
      };

      if (method === "POST" && data) {
        config.data = data;
        if (!(data instanceof FormData)) {
          config.headers = getHeader();
        }
      }

      const response = await axios(config);

      // Check if response status is successful (200-299)
      if (response.status >= 200 && response.status < 300) {
        workingUrl = currentParams.activeUrl;
        finalResponse = response;
      } else {
        console.log(`Current URL returned HTTP ${response.status}`);
      }
    } catch (error) {
      // Handle different types of errors
      if (error.response) {
        console.log(`Current URL returned HTTP ${error.response.status}`);
      } else if (error.request) {
        console.log(`Current URL - No response received:`, error.message);
      } else {
        console.log(`Current URL - Request error:`, error.message);
      }
    }
  }

  // If active URL failed, try all URLs in order
  if (!workingUrl) {
    for (const url of urls) {
      if (url === currentParams.activeUrl) continue; // Skip the one we already tried

      try {
        const config = {
          method,
          url: url + api + "?do=" + service,
          headers: method === "GET" ? getHeader() : getHeader2(),
        };

        if (method === "POST" && data) {
          config.data = data;
          if (!(data instanceof FormData)) {
            config.headers = getHeader();
          }
        }

        const response = await axios(config);

        // Check if response status is successful (200-299)
        if (response.status >= 200 && response.status < 300) {
          workingUrl = url;
          finalResponse = response;
          break; // Exit loop once we find a working URL
        } else {
          console.log(`URL ${url} returned HTTP ${response.status}`);
          continue;
        }
      } catch (error) {
        // Handle different types of errors
        if (error.response) {
          console.log(`URL ${url} returned HTTP ${error.response.status}`);
        } else if (error.request) {
          console.log(`URL ${url} - No response received:`, error.message);
        } else {
          console.log(`URL ${url} - Request error:`, error.message);
        }
        continue;
      }
    }
  }

  // If no URL worked, return error
  if (!workingUrl) {
    const error = new Error("Toutes les URLs ont échoué.");
    error.data = "";
    return error;
  }

  // Update storage if URL changed
  if (workingUrl !== currentParams.activeUrl) {
    currentParams.activeUrl = workingUrl;
    localStorage.setItem("param", JSON.stringify(currentParams));
  }

  return finalResponse;
}

// Your existing functions
export function axiosGetAction(api, service) {
  return callWithFailover("GET", api, service);
}

export function axiosPostAction(api, service, data) {
  let finalData = data;

  if (data && !(data instanceof FormData)) {
    finalData = JSON.stringify(data);
  }

  return callWithFailover("POST", api, service, finalData);
}

export const getCurrentDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0"); // jour sur 2 chiffres
  const month = String(today.getMonth() + 1).padStart(2, "0"); // mois sur 2 chiffres (0 = janvier)
  const year = today.getFullYear();

  return `${day}-${month}-${year}`;
};

export const isSameDay = (d1, d2) =>
  d1.getFullYear() === d2.getFullYear() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getDate() === d2.getDate();

export const getMonths = (arr) => {
  const monthNames = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ];

  return arr.map((m) => ({
    id: m,
    name: monthNames[m - 1],
  }));
};

export const createSearchBuilder = (config = []) => {
  return (obj) => {
    return config
      .map((field) => {
        if (typeof field === "function") return field(obj);
        return obj?.[field];
      })
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  };
};

export const buildCustomerSearch = createSearchBuilder([
  "zone",
  "zoneCode",
  "nom",
  "nomCommercant",
  "client",
  (c) =>
    `${c.zone || c?.client?.codeZone || c.zoneCode || ""} ${c.nom || c?.client?.nomCommercant || c.nomCommercant || ""}`,
  (c) => c.agent?.nickname,
]);
